import { FieldLayerWellsGroup } from '@/api/fields';
import { WellCreate, WellDetail, WellUpdate, WellDetailWithHistory } from '@/types/well';
import { apiClient } from './client';

export const wellsApi = {
  getOrganizationWells: async (): Promise<FieldLayerWellsGroup[]> => {
    const response = await apiClient.get<FieldLayerWellsGroup[]>('/wells/');
    return response;
  },

  // Get well details
  getWell: async (wellId: string): Promise<WellDetailWithHistory> => {
    console.log('Fetching well:', wellId);
    const response = await apiClient.get<WellDetailWithHistory>(`/wells/${wellId}`);
    console.log('Well response:', response);
    return response;
  },

  // Create new well
  createWell: async (wellData: WellCreate): Promise<WellDetail> => {
    const response = await apiClient.post<WellDetail>('/wells/', wellData);
    return response;
  },

  // Update well
  updateWell: async (wellId: string, wellData: WellUpdate): Promise<WellDetail> => {
    console.log('API: updateWell called with:', { wellId, wellData });
    const response = await apiClient.put<WellDetail>(`/wells/${wellId}`, wellData);
    console.log('API: updateWell response:', response);
    return response;
  },

  // Delete well
  deleteWell: async (wellId: string): Promise<void> => {
    await apiClient.delete(`/wells/${wellId}`);
  },
};

// Convenience exports
export const { getOrganizationWells, getWell, createWell, updateWell, deleteWell } = wellsApi;
